/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreTrash = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 13 15"
  >
    <path
      d="M12.458 3H.542a.563.563 0 0 0-.401.164.474.474 0 0 0-.138.384l.99 9.845c.08.773.775 1.607 1.617 1.607h7.78c.842 0 1.537-.834 1.618-1.607l.99-9.72c.014-.14-.036-.405-.139-.509a.563.563 0 0 0-.4-.164zM4 12.429c0 .315-.224.571-.5.571s-.5-.256-.5-.571V5.57C3 5.256 3.224 5 3.5 5s.5.256.5.571v6.858zm3 0c0 .315-.224.571-.5.571s-.5-.256-.5-.571V5.57C6 5.256 6.224 5 6.5 5s.5.256.5.571v6.858zm3 0c0 .315-.224.571-.5.571s-.5-.256-.5-.571V5.57C9 5.256 9.224 5 9.5 5s.5.256.5.571v6.858zM12.458 1c.3 0 .542.224.542.5s-.242.5-.542.5H.542C.242 2 0 1.776 0 1.5S.242 1 .542 1h3.25c-.3 0-.542-.224-.542-.5s.242-.5.542-.5h5.416c.3 0 .542.224.542.5s-.242.5-.542.5h3.25z"
      fill="currentColor"
    />
  </svg>
);

IconCoreTrash.displayName = 'IconCoreTrash';

IconCoreTrash.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreTrash);
IconCoreTrash.displayName = 'IconCoreTrash';
